import { createFileRoute } from '@tanstack/react-router';
import { PageStub } from '@/components/shared/PageStub';

export const Route = createFileRoute('/alfie/settings')({
  component: () => <PageStub title="Alfie Settings" description="Configure your AI assistant" />,
});
